module.exports = "bundles/dacc730baf4e4939a49f5b0287dee1e8.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/sprites.png
// module id = 51
// module chunks = 0